import React from "react";

interface LoadingCoupangProps {
  loading: boolean;
}

const LoadingCoupang: React.FC<LoadingCoupangProps> = ({ loading }) => {
  return (
    <>
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="flex space-x-2">
            <div className="dot w-1 h-1 bg-primary rounded-full animate-bounce"></div>
            <div className="dot w-1 h-1 bg-primary rounded-full animate-bounce delay-200"></div>
            <div className="dot w-1 h-1 bg-primary rounded-full animate-bounce delay-400"></div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingCoupang;
